var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActionBarColumn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.7 11.9",
    style: {
      enableBackground: "new 0 0 14.7 11.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C4566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,4.5c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S2.3,4.5,1.5,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,0C0.7,0,0.1,0.6,0.1,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S2.3,0,1.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,9c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S2.3,9,1.5,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,2.6h8.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2H5c-0.7,0-1.2,0.6-1.2,1.2S4.3,2.6,5,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,4.7H5c-0.7,0-1.2,0.5-1.2,1.2S4.3,7.1,5,7.1h8.5c0.7,0,1.2-0.5,1.2-1.2C14.7,5.2,14.2,4.7,13.5,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,9.2H5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h8.5c0.7,0,1.2-0.5,1.2-1.2S14.2,9.2,13.5,9.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionBarColumn);
export default __webpack_public_path__ + "static/media/icon-action-bar-column.a9b1cfae759baf77326e7b3fb6c8c8e8.svg";
export { ForwardRef as ReactComponent };